import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

import { getLoyaltyPrograms } from "shared/lib/golCopy";

import Img from "@components/FileServer/Img";
import Table from "@components/UI/Table";

import { FormContext } from "./Forms/HooksForm";
import LoyaltyCardForm from "./Forms/LoyaltyCardForm";

export function LoyaltyCards({ formVals, setFormVals, errors, setErrors }) {
  const { setSubmitPressed } = useContext(FormContext);
  const [showForm, setShowForm] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [index, setIndex] = useState(null);
  const [allLoyaltyPrograms, setAllLoyaltyPrograms] = useState([]);

  const loayaltyCards = formVals?.loyalties;
  const isEmpty = loayaltyCards.length === 0;

  useEffect(() => {
    async function loadData() {
      setAllLoyaltyPrograms(await getLoyaltyPrograms());
    }
    loadData();
  }, [allLoyaltyPrograms.length]);

  useEffect(() => {
    const blockSection = (attribute) => {
      const element = document.getElementById("loyaltyCards");
      if (element) {
        element.style.pointerEvents = attribute;
      }
    };

    if (showForm) {
      blockSection("none");
    }

    return () => {
      blockSection("auto");
      setErrors({
        ...errors,
        Id: false,
        MembershipId: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm]);

  const createNewLoyaltyCard = async () => {
    setIsNew(true);
    setSubmitPressed(false);
    setFormVals({
      ...formVals,
      loyalties: [
        ...formVals.loyalties,
        {
          Id: "",
          MembershipId: "",
        },
      ],
    });

    setIndex(formVals.loyalties.length);
    setShowForm(true);
  };

  const deleteLoyaltyCard = (loyaltie) => {
    const newLoyalties = formVals.loyalties.filter(
      (currentloyaltie) =>
        loyaltie.MembershipId !== currentloyaltie.MembershipId
    );

    setFormVals({ ...formVals, loyalties: newLoyalties });
  };

  const menuItems = (_, idx) => (
    <>
      <div
        role="button"
        className="profile-table__menu-item"
        id={`edit-loyaltie-${idx}`}
        onClick={async () => {
          await setIndex(idx);
          return await setShowForm(true);
        }}
      >
        <FormattedMessage id="Profile.editLoyaltyCard" />
      </div>

      <div
        role="button"
        className="profile-table__menu-item"
        id={`delete-loyalties-${idx}`}
        onClick={() => {
          return deleteLoyaltyCard(formVals.loyalties[idx]);
        }}
      >
        <FormattedMessage id="Profile.deleteLoyaltyCard" />
      </div>
    </>
  );

  return (
    <div>
      {showForm && (
        <>
          <LoyaltyCardForm
            formVals={formVals}
            index={index}
            setFormVals={setFormVals}
            allLoyaltyPrograms={allLoyaltyPrograms}
            errors={errors}
            setErrors={setErrors}
          />
          <button
            type="submit"
            validate-button="true"
            className="profile-modal__save"
            id="save-loalty-card"
            onClick={() => {
              if (
                Object.values({ ...errors.Id, ...errors.MembershipId }).every(
                  (v) => !v
                )
              ) {
                setShowForm(false);
                setIsNew(false);
              }
            }}
          >
            <FormattedMessage id="Profile.saveChanges" />
          </button>
          {isNew && (
            <button
              type="button"
              className="profile-modal__open-remove-btn"
              onClick={() => {
                setShowForm(false);
                deleteLoyaltyCard(formVals.loyalties[index]);
                setIsNew(false);
              }}
            >
              <FormattedMessage id="Profile.cancel" />
            </button>
          )}
        </>
      )}

      {isEmpty && !showForm && (
        <div className="profile-main__card">
          <div className="profile-main__card--empty">
            <Img src="/static/images/loyalty-cards.svg" />
            <div className="profile-main__card-desc">
              <FormattedMessage id="Profile.noLoyaltyCards" />
            </div>
            <div
              role="button"
              onClick={() => createNewLoyaltyCard()}
              className="fake-link"
              id="new-loyalty-card-inner-link"
            >
              <FormattedMessage id="Profile.addLoyaltyCard" />
            </div>
          </div>
        </div>
      )}

      {!isEmpty && !showForm && (
        <div>
          <Table
            rows={loayaltyCards.map((d) => [
              d.MembershipId,
              allLoyaltyPrograms.find((p) => p.value === d.Id)?.label,
            ])}
            data={loayaltyCards}
            menuItems={menuItems}
            className="loyalty-cards"
          />
          <button
            type="button"
            className="profile-modal__save"
            onClick={() => createNewLoyaltyCard()}
          >
            <FormattedMessage id="Profile.addNew" />
          </button>
        </div>
      )}
    </div>
  );
}
